import { Banknote, Loader2, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { CurrencyField } from "@/components/ui/forms";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fmtDateTime } from "@/lib/datetime";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

// Registrar Gasto / Nómina — presentacional. Incluye lista de comprobantes del turno (reimpresión).
export const GastoDialog = ({
  gastoOpen, setGastoOpen, gastoMonto, setGastoMonto, gastoCategoria, setGastoCategoria,
  gastoConcepto, setGastoConcepto, registrarGasto, gastoSaving,
  gastosTurno = [], gastosLoading = false, onReimprimirGasto,
}) => (
  <Dialog open={gastoOpen} onOpenChange={setGastoOpen}>
    <DialogContent className="bg-[#0F0F0F] border-white/10 text-white sm:max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="gasto-modal">
      <DialogHeader>
        <DialogTitle className="font-display uppercase tracking-wider flex items-center gap-2"><Banknote className="h-5 w-5 text-[#F59E0B]" /> Registrar Gasto / Nómina</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 pt-1">
        <div>
          <label className="text-[10px] uppercase tracking-wider font-bold text-white/50">Monto ($ MXN)</label>
          <CurrencyField inputMode="decimal" value={gastoMonto} onChange={(v) => setGastoMonto(v)} placeholder="0.00"
            data-testid="gasto-monto-input" className="mt-1 h-12 rounded-none bg-white/5 border-white/20 text-white text-lg font-display" />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wider font-bold text-white/50">Categoría</label>
          <Select value={gastoCategoria} onValueChange={setGastoCategoria}>
            <SelectTrigger className="mt-1 h-11 rounded-none bg-white/5 border-white/20 text-white" data-testid="gasto-categoria-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="Nómina/Salario">Nómina/Salario</SelectItem>
              <SelectItem value="Insumos">Insumos</SelectItem>
              <SelectItem value="Mantenimiento">Mantenimiento</SelectItem>
              <SelectItem value="Pago a Proveedor">Pago a Proveedor</SelectItem>
              <SelectItem value="Otro">Otro</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wider font-bold text-white/50">Concepto (obligatorio)</label>
          <Input value={gastoConcepto} onChange={(e) => setGastoConcepto(e.target.value)} placeholder="Ej. Pago de nómina turno noche"
            data-testid="gasto-concepto-input" className="mt-1 h-11 rounded-none bg-white/5 border-white/20 text-white" />
        </div>
        <button onClick={registrarGasto} disabled={gastoSaving} data-testid="gasto-guardar-btn"
          className="btn-hard w-full h-12 bg-[#F59E0B] text-[#0A0A0A] border border-[#0A0A0A] font-black uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-50">
          {gastoSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Banknote className="h-4 w-4" />} Guardar gasto
        </button>

        {/* Comprobantes de gasto del turno — reimpresión (no re-registra ni descuenta) */}
        <div className="pt-2 border-t border-white/10" data-testid="gasto-comprobantes">
          <div className="text-[10px] uppercase tracking-wider font-bold text-white/50 mb-2">Comprobantes del turno</div>
          {gastosLoading ? (
            <div className="flex items-center justify-center py-4"><Loader2 className="h-4 w-4 animate-spin text-white/40" /></div>
          ) : gastosTurno.length === 0 ? (
            <div className="text-xs text-white/40 py-2">Aún no hay gastos registrados en este turno.</div>
          ) : (
            <div className="space-y-2 max-h-56 overflow-y-auto">
              {gastosTurno.map((g) => (
                <div key={g.id} data-testid={`gasto-row-${g.id}`} className="flex items-center gap-2 bg-white/5 border border-white/10 p-2">
                  <div className="flex-1 min-w-0">
                    <div className="font-display text-sm text-white">{money(g.monto)} <span className="text-[10px] uppercase tracking-wider text-[#F59E0B]">{g.categoria || "Otro"}</span></div>
                    <div className="text-xs text-white/60 truncate">{g.concepto || "-"}</div>
                    <div className="text-[10px] text-white/40">{fmtDateTime(g.fecha)}{g.operador ? ` · ${g.operador}` : ""}</div>
                  </div>
                  <button onClick={() => onReimprimirGasto?.(g)} data-testid={`gasto-reimprimir-${g.id}`}
                    className="btn-hard h-9 px-3 bg-[#F59E0B]/15 border border-[#F59E0B]/50 text-[#F59E0B] text-[10px] font-bold uppercase tracking-wider flex items-center gap-1 hover:bg-[#F59E0B]/25 shrink-0">
                    <Printer className="h-3.5 w-3.5" /> Reimprimir
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default GastoDialog;
